// extracted by mini-css-extract-plugin
module.exports = {"inputRoot":"DateRangeController_inputRoot__c6FR5","arrowIcon":"DateRangeController_arrowIcon__31cd8"};